// @flow

import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  from {
    transform: translate(-50%, -50%) scale(3);
  }

  to {
    transform: translate(-50%, -50%) scale(1);
  }
`;

export const Loading = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);

  width: 15px;
  height: 15px;
  border-radius: 50%;

  background-color: #666;

  animation: ${pulse} .6s linear infinite;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents.js